import { Action } from '@ngrx/store';
import { SnackbarData } from '../models';

export const OPEN: string = '[Notification] OPEN NOTIFICATION';
export const DISMISS: string = '[Notification] CLOSE NOTIFICATION';
export const DISMISSING: string = '[Notification] CLOSING NOTIFICATION';
export const ADD_NOTIFICATION: string = '[Notification] ADD NOTIFICATION';

export class Open implements Action {
  readonly type = OPEN;
  constructor(public payload: SnackbarData) {}
}

export class Dismiss implements Action {
  readonly type = DISMISS;
  constructor(public payload = null) {}
}

export class Dismissing implements Action {
  readonly type = DISMISSING;
  constructor(public payload = null) {}
}

export class AddNotification implements Action {
  readonly type = ADD_NOTIFICATION;
  constructor(public payload: SnackbarData) {}
}

export type All = Open | Dismiss | Dismissing | AddNotification;
